import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleInstallmentSelected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#56A" opacity={0.88} cx={28} cy={28} r={28} />
        <path
          d="M35.62 20.35H17.75a.74.74 0 01-.75-.72c0-.4.34-.73.75-.73h18c.41 0 .75-.32.75-.72 0-1.2-1-2.18-2.25-2.18H17c-1.66 0-3 1.3-3 2.9v14.5c0 1.6 1.34 2.9 3 2.9h18.62c1.31 0 2.38-.97 2.38-2.17v-11.6c0-1.2-1.07-2.18-2.38-2.18zm-2.12 9.43c-.83 0-1.5-.65-1.5-1.45 0-.8.67-1.45 1.5-1.45s1.5.65 1.5 1.45c0 .8-.67 1.45-1.5 1.45z"
          fill="#FFF"
        />
        <g transform="translate(30 28)">
          <circle fill="#8F9DD6" cx={8} cy={8} r={8} />
          <path
            stroke="#FFF"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8 4.2v3.65l3 2.18"
          />
        </g>
      </g>
    </svg>
  );
}

SvgPicCircleInstallmentSelected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleInstallmentSelected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleInstallmentSelected svgRef={ref} {...props} />
));
export default ForwardRef;
